var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.image)?_c('div',{staticClass:"landing-background-image",style:(_vm.backgroundImageStyle)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }